import React from 'react';
import axios from 'axios'

import loading from './images/loading.gif';
import esf_logo from './images/esf_logo.svg';
import esif_logo from './images/esif_logo.svg';
import EU_logo from './images/EU_logo2.svg';
import projekt_logo from './images/projekt_logo_mali.svg';

import ArticleTitle from './subpage/ArticleTitle'
import ArticleImage from './subpage/ArticleImage'
import ArticleLead from './subpage/ArticleLead'
import ArticleContent from './subpage/ArticleContent'
import Gallery from './subpage/Gallery'
import ProjectText from './subpage/ProjectText'
import BackLink from './subpage/BackLink'

const apiRoot = 'https://crrp.hr'

export default class Subpage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      page_id: "",
      data: []
    }
  }

  componentDidMount() {
    this.getData(window.location.href.split("#")[1])
  }

  getData = (page_id="") => {

    this.setState({loaded: false, page_id: page_id})

    let api_call = page_id === "" ? apiRoot + '/subpages/' + this.props.site : apiRoot + '/subpages/' + this.props.site + '/' + page_id

    axios.get(api_call)
    .then(response => {
      this.setState({data: response.data, loaded: true})
    })
    .catch(error => console.log(error))
  }

  render() {

    const { loaded, data, page_id } = this.state

    const homepage_content =
      <React.Fragment>
        <ProjectText getData={this.getData} site={this.props.site} />
        <div className="back_link"><a href="/">Početna</a></div>
        {data.map((article) =>
        <div style={{marginLeft: '235px'}}>
          <a href={"#"+article.slug} onClick={() => this.getData(article.slug)}>
            <article className="index_article" key={article.id}>
              <ArticleImage article={article} apiRoot={apiRoot} />
              <ArticleTitle article={article} hasLink={page_id === ""} />
              {this.props.site === "crrp" ? null : <ArticleLead article={article} />}
            </article>
          </a>
        </div>
        )}
      </React.Fragment>


    const article_content = data.map((article) =>
    <React.Fragment>
      <BackLink className="back_link" article={article} getData={this.getData} />
      <article className="article_content" key={article.id}>
        <ArticleTitle article={article} hasLink={page_id === ""} />
        <ArticleContent article={article} />
      </article>
      <Gallery gallery_images={article.gallery_images} apiRoot={apiRoot} />
    </React.Fragment>
    )

    const logos = <div className="logos">
        <img height={80} alt ="projekt_logo" src={projekt_logo} />
        <img height={80} alt ="EU_logo" src={EU_logo} />
        <img height={80} alt ="esf_logo" src={esf_logo} />
        <img height={80} alt ="esif_logo" src={esif_logo} />
        <div className="disclamer" style={{textAlign: 'center', color: '#003399', width: '100%'}}>
          <p>
            Projekt je sufinancirala Europska unija iz Europskog socijalnog fonda
            <br />
            Sadržaj ove internetske stranice isključiva je odgovornost Centra za razvoj radničke participacije.
          </p>
        </div>
    </div>

    const content = page_id === "" ? homepage_content : article_content

    return (<section className={page_id === "" ? "index_articles_section" : "content_section"}>
      {loaded ? <React.Fragment>{content}{logos}</React.Fragment> : <img alt="loading" src={loading} />}
    </section>)
  }
}
